import { __assign, __rest } from "tslib";
import * as React from 'react';
import AnimatableDiv from './AnimatableDiv';
import { mouseEventProps } from './mouseEventProps';
import { applyAttributeStyles, joinClass } from './symbolUtils';
var attributeStyleMap = {
    backgroundImageStyle: {
        cover: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
        contain: {
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
        },
        auto: {
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
        },
    },
};
export var Image = function (_a) {
    var conditionalState = _a.conditionalState, hoverAnimation = _a.hoverAnimation, innerRef = _a.innerRef, inEditor = _a.inEditor, symbol = _a.symbol, timelineRefId = _a.timelineRefId;
    var _b = mouseEventProps(symbol, inEditor, hoverAnimation), clickClass = _b.clickClass, mouseEventStyles = _b.mouseEventStyles, onClick = _b.onClick;
    var attributes = conditionalState.attributes, position = conditionalState.position, styles = conditionalState.styles;
    var backgroundImage = styles.backgroundImage, backgroundPosition = styles.backgroundPosition, otherStyles = __rest(styles, ["backgroundImage", "backgroundPosition"]);
    var attributeStyles = applyAttributeStyles(attributes, attributeStyleMap);
    var className = joinClass(symbol.id, conditionalState.id, clickClass);
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: innerRef, onClick: onClick, position: position, style: __assign(__assign(__assign({}, mouseEventStyles), otherStyles), { display: 'flex', overflow: 'hidden' }), inEditor: inEditor },
        React.createElement("div", { style: __assign({ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundImage: "url(" + styles.backgroundImage + ")", backgroundPosition: backgroundPosition || 'center' }, attributeStyles) })));
};
export default Image;
